<template>
  <div class="not-front documents">

    <Header/>

    <div id="mainwrapper">
      <div class="container">

        <Sidebar/>

        <router-view />
        
      </div>
    </div>  
  </div>
</template>

<script>
import Sidebar from '@/components/app/Sidebar.vue'
import Header from '@/components/app/Header.vue'

export default {
  name: 'main-layout',
  components: {
    Sidebar, Header,
  }
}
</script>